export const SERVICES = [
  {
    id: "web-dev",
    title: "Web Development",
    icon: "🌐",
    gradient: "linear-gradient(135deg, #C8352B20, #C8352B05)",
    borderColor: "#C8352B",
    description: "We build fast, responsive, and engaging websites tailored to your brand identity. From landing pages to full-featured web applications, our development process focuses on user experience, performance optimization, and modern design principles that convert visitors into customers.",
    features: [
      "Responsive & Mobile-First Design",
      "SEO Optimized Architecture",
      "Fast Loading & Performance Tuned",
      "Ongoing Maintenance & Support"
    ],
    techStack: ["React", "Next.js", "Node.js", "Tailwind CSS"],
    caseStudy: {
      name: "Vacademy Raichur",
      role: "Landing Page & Platform Interface",
      result: "Increased student engagement through clean visual hierarchies and optimized delivery structures.",
      link: "https://vacademy.co.in/",
      images: [
        "/assets/Vacademy/1.png",
        "/assets/Vacademy/2.png",
        "/assets/Vacademy/3.png",
        "/assets/Vacademy/4.png",
        "/assets/Vacademy/5.png",
        "/assets/Vacademy/6.png",
        "/assets/Vacademy/7.png",
        "/assets/Vacademy/8.png",
        "/assets/Vacademy/9.png"
      ]
    }
  },
  {
    id: "saas",
    title: "Software as a Service",
    icon: "☁️",
    gradient: "linear-gradient(135deg, #5B44C920, #5B44C905)",
    borderColor: "#5B44C9",
    description: "We engineer scalable SaaS platforms that solve real business problems. Our solutions include multi-tenant architecture, subscription management, analytics dashboards, and enterprise-grade security. Whether you're starting from scratch or migrating existing systems, we build software that grows with you.",
    features: [
      "Multi-Tenant Architecture",
      "Subscription & Billing Integration",
      "Role-Based Access Control (RBAC)",
      "Real-Time Analytics Dashboards",
      "API-First Development"
    ],
    techStack: ["React", "Node.js", "MySQL", "Python"],
    caseStudy: {
      name: "East Point Complaint Management System (EPCMS)",
      role: "Full-Stack Enterprise Web Application",
      result: "Digitized grievance redressal across 9+ campuses with 50+ complaint handlers and 5-layer automated routing logic.",
      link: "#featured",
      images: [
        "./assets/epcm/1.png",
        "./assets/epcm/2.png",
        "./assets/epcm/3.png",
        "./assets/epcm/4.png",
        "./assets/epcm/5.png",
        "./assets/epcm/6.png",
        "./assets/epcm/7.png",
        "./assets/epcm/8.png",
        "./assets/epcm/9.png",
        "./assets/epcm/10.png",
        "./assets/epcm/11.png",
        "./assets/epcm/12.png",
        "./assets/epcm/13.png"
      ]
    }
  },
  {
    id: "deployment",
    title: "Deployment & Hosting",
    icon: "🚀",
    gradient: "linear-gradient(135deg, #D4900A20, #D4900A05)",
    borderColor: "#D4900A",
    description: "We maintain our own dedicated server infrastructure to deploy and host your web applications, websites, and services. No third-party downtime surprises — you get guaranteed uptime, automated backups, security monitoring, and 24/7 technical support. We handle the infrastructure so you can focus on your business.",
    features: [
      "Dedicated Server Infrastructure",
      "99.9% Uptime Guarantee",
      "Automated Daily Backups",
      "DDoS Protection & Security Monitoring",
      "24/7 Technical Support",
      "Scalable Resources On-Demand"
    ],
    techStack: ["Ubuntu Server", "Nginx", "Kubernetes", "CloudFlare", "PM2"],
    caseStudy: {
      name: "A Sweet Spot Hosting Solutions",
      role: "Managed Hosting for Multiple Institutions",
      result: "Seamless deployment of production applications with zero downtime and automated resource partitioning.",
      link: "#contact",
      images: ["./assets/epcm/14.jpg"]
    }
  }
];